export const getOrganizationNewsletterSubscribersApiHandler = {
  method: "GET",
  path: () => `organizations-dashboard/newsletter-subscribers`,
  params: {} as {'skip'?: string | number, 'take'?: string | number}
};